import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../../../../../../Components/CustomUi/inline'
import { CardListar, ContainerLista, ModalCopiaAnalises } from './styled'
import { faCopy, faDownload, faEye, faTrash } from '@fortawesome/free-solid-svg-icons'
import { LineDivider } from '../../../../../../../../../../Components/CustomUi/LineDivider'
import { PontosAnalises } from './components/pontos'
import { calcularPorcentagem } from '../../../../../meta'
import { calculoAreaCoord } from '../../../../../../../../../../services/Afins'
import { LabAnaliseItens } from '../../../../../../../../../../services/LabAnalise'
import { useEffect, useState } from 'react'
import { ModalCopiarAnalises } from './components/modalCopiarAnalises'
import { GeoPointFeature } from '../headerAnalises/components/modalNovaAnalise'

interface PropsListarAnalises {
  analises: any[]
  grupoAnalises: LabAnaliseItens[]
  pontos: number
  talhaoArea: string
  amostra: string
  propriedade_area: string
  inserirPontosSelecionados: Function
  copiarAnalise: Function
  removerPonto: (analiseId: string | number, pontoNome: number | string) => void
  setAnalises: React.Dispatch<React.SetStateAction<any[]>>
}

export const ListarAnalises: React.FC<PropsListarAnalises> = ({
  analises,
  grupoAnalises,
  pontos,
  talhaoArea,
  amostra,
  propriedade_area,
  inserirPontosSelecionados,
  copiarAnalise,
  removerPonto,
  setAnalises
}) => {

  const [abrirModalCopia, setAbrirModalCopia] = useState<boolean>(false)
  const [pontos_selecionados_copia, setPontosSelecionados_copia] = useState<GeoPointFeature[]>([])

  const calcularAmostraHa = () => {
    const ha = Number(propriedade_area)
    const am = parseFloat(amostra)
    if (!am || isNaN(ha) || isNaN(am) || am <= 0) return '0.00'

    const calc = ha / am
    if (isNaN(calc) || calc <= 0) return '0.00'
    const calcFixed = parseFloat(calc.toFixed(2))
    if (!calcFixed) return '0.00'

    const total = ha / calcFixed
    return isFinite(total) ? total.toFixed(2) : '0.00'
  }

  function copiarAnalises(item) {
    setAbrirModalCopia(true)
    setPontosSelecionados_copia(item?.pontos_selecionados)
  }

  function deletarAnalise(analiseId: string | number) {
    setAnalises((prev) => prev.filter((a) => a?.id !== analiseId))
  }

  function baixarKmlAnalise(item: any) {
    const pontos = item?.pontos_selecionados || []
    const nomeAnalise = item?.analise_nome || 'analise'
    const profundidade = item?.profundidade || ''

    const placemarks = pontos.map((p: any) => {
      const nome = p?.NOME?.toString().padStart(2, '0') || ''
      const lat = p?.LATITUDE || 0
      const lng = p?.LONGITUDE || 0
      return `    <Placemark>
        <name>${nome}</name>
        <description>Análise: ${nomeAnalise} | Profundidade: ${profundidade}</description>
        <Point>
          <coordinates>${lng},${lat},0</coordinates>
        </Point>
      </Placemark>`
    }).join('\n')

    const kml = `<?xml version="1.0" encoding="UTF-8"?>
    <kml xmlns="http://www.opengis.net/kml/2.2">
      <Document>
        <name>${nomeAnalise} - ${profundidade}</name>
        ${placemarks}
      </Document>
    </kml>`

    const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${nomeAnalise}_${profundidade}.kml`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const calcularMediaHaPorPonto = (area: any, listaPontos: any[]) => {
    if (!area && area !== 0) return '0.00'

    const areaStr = String(area).replace(/[^0-9.,]/g, '').replace(',', '.')
    const areaTratada = Number(areaStr)
    const qtdPontos = listaPontos?.length || 0

    if (isNaN(areaTratada) || areaTratada <= 0 || qtdPontos <= 0) {
      return '0.00'
    }

    const resultado = areaTratada / qtdPontos
    return isFinite(resultado) ? resultado.toFixed(2) : '0.00'
  }


  return (
    <ContainerLista>
      {analises.map((item, index) => (

        <CardListar key={index}>
          <div className='card__header'>
            <div className='header__infos'>
              <div style={{ backgroundColor: item?.cor }}>{item?.analise_nome}</div>
              <p style={{ color: item?.cor }}>{item?.profundidade}</p>
            </div>
            <div className='header__infos__buttons'>
              <ButtonCustom
                type='secondary'
                onClick={() => copiarAnalises(item)}
                icon={<FontAwesomeIcon icon={faCopy} />}
              />
              <ButtonCustom
                type='primary'
                onClick={() => baixarKmlAnalise(item)}
                icon={<FontAwesomeIcon icon={faDownload} />}
              />
              <ButtonCustom
                type='primary'
                danger
                onClick={() => deletarAnalise(item?.id)}
                icon={<FontAwesomeIcon icon={faTrash} />}
              />
            </div>
          </div>
          <LineDivider />
          <PontosAnalises initialPoints={item?.pontos_selecionados} inserirPontosSelecionados={inserirPontosSelecionados} id={item?.id} cod_analise={item?.cod_analise} removerPonto={removerPonto} />
          <LineDivider />
          <div className='detalhes__analise'>
            <h3>Detalhes</h3>
            <div className='info__detalhes'>
              <div className='detalhes' data-active={true}>
                <span>Valor</span>
                <strong>{item?.valor_analise}</strong>
              </div>
              <div className='detalhes'>
                <span>Amostras</span>
                <strong>{`${item?.pontos_selecionados?.length} de ${pontos} ${calcularPorcentagem(
                  item?.pontos_selecionados?.length,
                  pontos
                )}`}</strong>
              </div>
              <div className='detalhes'>
                <span>Grid amostral</span>
                <strong>
                  {calcularMediaHaPorPonto(talhaoArea, item?.pontos_selecionados)}{' '}
                  ha/ponto
                </strong>
              </div>
            </div>
            <div className='detalhes__observacao'>
              <span>Observação</span>
              <p>{calcularAmostraHa()} ha para cada amostra</p>
            </div>
          </div>
        </CardListar>

      ))}
      <ModalCopiarAnalises
        abrirModalCopia={abrirModalCopia}
        setAbrirModalCopia={setAbrirModalCopia}
        pontos_selecionados={pontos_selecionados_copia}
        grupoAnalises={grupoAnalises}
        analises={analises}
        setAnalises={setAnalises}
      />
    </ContainerLista>
  )
}
